import Kicker from "components/Kicker"
import Testimonials from "components/Testimonials"
import { graphql, useStaticQuery } from "gatsby"
import UniversalImage from "library/UniversalImage"
import { fmobile, fresponsive, ftablet } from "library/fullyResponsive"
import useMedia from "library/useMedia"
import styled, { css } from "styled-components"
import colors from "styles/colors"
import textStyles from "styles/text"

export default function TestimonialsSection() {
	const mobile = useMedia(false, false, false, true)

	const homeQuotesImages: Queries.HomeQuotesQuery = useStaticQuery(graphql`
		query HomeQuotes {
			leftAlpineSteps: file(relativePath: { eq: "AlpineStepsLeft.png" }) {
				childImageSharp {
					gatsbyImageData(placeholder: NONE)
				}
			}
			rightAlpineSteps: file(relativePath: { eq: "AlpineStepsRight.png" }) {
				childImageSharp {
					gatsbyImageData(placeholder: NONE)
				}
			}
			tabletAlpineSteps: file(relativePath: { eq: "AlpineStepsTablet.png" }) {
				childImageSharp {
					gatsbyImageData(placeholder: NONE)
				}
			}
			mobileAlpineSteps: file(relativePath: { eq: "AlpineStepsMobile.png" }) {
				childImageSharp {
					gatsbyImageData(placeholder: NONE)
				}
			}
		}
	`)

	const desktopFullWidthAccents = (
		<>
			<LeftSteps
				image={homeQuotesImages.leftAlpineSteps}
				alt="Background Steps Accent"
			/>
			<RightSteps
				image={homeQuotesImages.rightAlpineSteps}
				alt="Background Steps Accent"
			/>
		</>
	)

	const bgAccents = useMedia(
		desktopFullWidthAccents,
		desktopFullWidthAccents,
		<TabletSteps
			image={homeQuotesImages.tabletAlpineSteps}
			alt="Background Steps Accent"
		/>,
		<MobileSteps
			image={homeQuotesImages.mobileAlpineSteps}
			alt="Background Steps Accent"
		/>,
	)

	return (
		<Wrapper>
			{bgAccents}
			<Top>
				<Kicker barcodes="double" variant="long">
					Tried and True
				</Kicker>
				<Title>
					Hear It From Our Trusted <Strong>Customers</Strong>
				</Title>
			</Top>
			<Cards>
				<Testimonials backgroundColor="white" sidePadding={mobile ? 12 : 46} />
			</Cards>
		</Wrapper>
	)
}

const Wrapper = styled.section`
	${fresponsive(
		css`
			width: 100vw;
			display: grid;
			place-items: center;
			left: 50%;
			transform: translateX(-50%);
			padding: 118px 46px 116px;
			background-color: ${colors.pureWhite};
			position: relative;
		`,
		{ scaleFully: true },
	)}

	${ftablet(css`
		padding: 136px 0 11px;
		display: block;
	`)}

  ${fmobile(css`
		width: 375px;
		padding: 169px 0 12px;
		display: block;
	`)}
`

const Top = styled.div`
	${fresponsive(css`
		width: 1000px;
		display: flex;
		flex-direction: column;
		gap: 30px;
		align-items: center;
		text-align: center;
		margin: 0 auto;
	`)}

	${ftablet(css`
		align-items: flex-start;
		text-align: left;
		padding-left: 45px;
		margin: unset;
	`)}

	${fmobile(css`
		width: 100%;
		align-items: flex-start;
		text-align: left;
		padding-left: 12px;
		margin: unset;
		gap: 18px;
	`)}
`

const Cards = styled.div`
	${ftablet(css`
		width: 100%;
		padding: 0 0 20px;
	`)}

	${fmobile(css`
		width: 100%;
		padding: 0 0 8px;
	`)}
`

const Title = styled.div`
	${fresponsive(css`
		${textStyles.h2uncapped};
		margin: -10px 0 99px;
		width: 100%;
	`)}

	${ftablet(css`
		margin: -10px 0 50px;
	`)}

  ${fmobile(css`
		width: 352px;
		${textStyles.h4};
		margin: -5px 0 27px;
	`)}
`

const Strong = styled.strong`
	color: ${colors.blue2};
`

const Steps = styled(UniversalImage)`
	${fresponsive(css`
		position: absolute;
		width: 678px;
		height: 159.25px;
		top: -30.75px;
	`)}
`

const LeftSteps = styled(Steps)`
	${fresponsive(css`
		left: -8px;
	`)}
`

const RightSteps = styled(Steps)`
	${fresponsive(css`
		right: -8px;
	`)}
`

const TabletSteps = styled(Steps)`
	${fresponsive(css`
		width: 898px;
		height: 232.5px;
		right: -110px;
		top: -48px;
	`)}
`

const MobileSteps = styled(Steps)`
	${fresponsive(css`
		width: 960px;
		height: 164px;
		top: -27px;
		left: -473px;
	`)}
`
